import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesEnum } from '../routing/routes.enum';
import { ECPStore } from '../state-management/stores/ecp.store';

export const selectedSoldtoGuard: CanActivateFn = async (route, state) => {
	const router = inject(Router);
	const ecpStore = inject(ECPStore);

	if (!ecpStore.selectedSoldToStore()) {
		router.navigate([RoutesEnum.storeSelection]);
		return false;
	} else {
		return true;
	}
};
